import React, { useEffect, useState } from "react"
import './App.css'
import ps_logo from './assets/ps_logo.png'
import ps_flower from './assets/ps_flower.png'
import axios from 'axios'
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation"
import DIVISIONS from './assets/divisions'
import Select from "react-select"
import { FaCheck, FaSpinner, FaArrowLeft, FaArrowRight } from 'react-icons/fa'
import { IconContext } from "react-icons";
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import {
  Alert,
  Card,
  CardBody,
  Col,
  Row,
  Label,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Container,
  Button,
  FormFeedback,
} from "reactstrap"
import DatePicker from 'react-datepicker'

const none = {
  label: '-',
  value: 0,
}

const STEPS = [
  { label: 'Të dhënat personale', shortLabel: 'Personale' },
  { label: 'Arsimimi', shortLabel: 'Arsimimi' },
  { label: 'Punësimi', shortLabel: 'Punësimi' },
  { label: 'Kontakt', shortLabel: 'Kontakt' },
  { label: 'Vendndodhja', shortLabel: 'Vendndodhja' },
  { label: 'Konfirmimi', shortLabel: 'Konfirmim' },
]

function App() {
  const API_URL = 'https://backend.ps.al'
  const APPLY_URL = '/api/hr/membership-apply/'
  const CONFIRM_URL = '/api/hr/membership-application-confirm-phone/'
  const REGENERATE_URL = '/api/hr/membership-application-recreate-phone-confirmation/'

  const [currentStep, setCurrentStep] = useState(0)

  const [applied, setApplied] = useState(false)
  const [shouldUpdate, setShouldUpdate] = useState(false)
  const [time, setTime] = useState(120)

  const [name, setName] = useState('')
  const [surname, setSurname] = useState('')
  const [father_name, setFatherName] = useState('')
  const [mother_name, setMotherName] = useState('')
  const [nid, setNid] = useState('')
  const [card_nid_expiry_date, setNidExpiry] = useState('')
  const [birthplace, setBirthplace] = useState('')
  const [birthdate, setBirthdate] = useState('')
  const [gender, setGender] = useState('')
  const [membership_year, setMembershipYear] = useState(0)

  const [yes_primary, setYesPrimary] = useState(false)
  const [no_primary, setNoPrimary] = useState(false)
  const [primary_education_desc, setPrimaryName] = useState('')

  const [yes_highschool, setYesHighschool] = useState(false)
  const [no_highschool, setNoHighschool] = useState(false)
  const [high_school_desc, setHighSchoolName] = useState('')

  const [yes_university, setYesUniversity] = useState(false)
  const [no_university, setNoUniversity] = useState(false)
  const [university_desc, setUniversityName] = useState('')

  const [yes_masters_degree, setYesMasters] = useState(false)
  const [no_masters_degree, setNoMasters] = useState(false)
  const [master_degree_desc, setMastersName] = useState('')

  const [yes_scientific_title, setYesScientific] = useState(false)
  const [no_scientific_title, setNoScientific] = useState(false)
  const [scientific_title_desc, setScientificName] = useState('')

  const [yes_state_employed, setYesStateEmployed] = useState(false)
  const [no_state_employed, setNoStateEmployed] = useState(false)
  const [state_employed_position, setStateName] = useState('')

  const [yes_private_sector_employed, setYesPrivateSector] = useState(false)
  const [no_private_sector_employed, setNoPrivateSector] = useState(false)
  const [private_sector_position, setPrivateName] = useState('')

  const [is_self_employed, setSelfEmployedStatus] = useState(false)
  const [is_unemployed, setUnemployedStatus] = useState(false)
  const [is_student, setStudentStatus] = useState(false)
  const [is_retired, setRetiredStatus] = useState(false)

  const [phone, setPhone] = useState('')
  const [email, setEmail] = useState('')
  const [facebook_link, setFacebookLink] = useState('')
  const [twitter_link, setTwitterLink] = useState('')
  const [instagram_link, setInstagramLink] = useState('')
  const [address, setAddress] = useState('')
  const [references, setReferences] = useState('')
  const [qv_code, setQVCode] = useState(0)

  const [started, setStarted] = useState(false)
  const [regions, setRegions] = useState([])

  const [region_options, setRegionOptions] = useState([none])
  const [selected_region, setSelectedRegion] = useState(none)

  const [municipality_options, setMunicipalityOptions] = useState([none])
  const [selected_municipality, setSelectedMunicipality] = useState(none)

  const [unit_options, setUnitOptions] = useState([none])
  const [selected_unit, setSelectedUnit] = useState(none)

  const [action_uuid, setUUID] = useState('')
  const [confirmation_id, setConfirmationId] = useState(0)
  const [confirmation_code, setConfirmationCode] = useState('')
  const [privacy, setPrivacy] = useState(false)

  const [stepError, setStepError] = useState('')
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [width, setWidth] = useState(window.innerWidth)

  const [apply_loading, setApplyLoading] = useState(false)
  const [refresh_loading, setRefreshLoading] = useState(false)
  const [confirm_loading, setConfirmLoading] = useState(false)
  const [confirmed, setConfirmed] = useState(false)
  const [captchaMessage, setCaptchaMessage] = useState('')
  const [captchaSuccess, setCaptchaSuccess] = useState(false)
  const [captchaError, setCaptchaError] = useState(false)
  const [startDate, setStartDate] = useState(new Date())

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  let isMobile = (width <= 768)

  const handleSelectRegion = selectedGroup => {
    let munic = regions.filter(opt => { return opt.id === selectedGroup.value })
    let municip = munic[0].municipalities
    let municipality_options = municip.map(opt => ({ label: opt.name, value: opt.id }))
    setSelectedRegion(selectedGroup)
    setSelectedMunicipality(none)
    setMunicipalityOptions(municipality_options)
    setSelectedUnit(none)
    setUnitOptions([])
  }

  const handleSelectMunicipality = selectedGroup => {
    let munic = regions.filter(opt => { return opt.id === selected_region.value })
    let municip = munic[0].municipalities

    let un = municip.filter(opt => { return opt.id === selectedGroup.value })
    let units = un[0].units
    let unit_options = units.map(opt => ({ label: opt.name, value: opt.id }))

    setSelectedMunicipality(selectedGroup)
    setSelectedUnit(none)
    setUnitOptions(unit_options)
  }

  const handleSelectUnit = selectedGroup => {
    setSelectedUnit(selectedGroup)
  }

  useEffect(() => {
    if (!started) {
      window.addEventListener('resize', handleWindowSizeChange);

      let divisions = DIVISIONS.divisions
      let region_list = [...divisions[0].regions]
      region_list.push.apply(region_list, divisions[1].regions)
      region_list.push.apply(region_list, divisions[2].regions)

      let region_options = region_list.map(opt => ({ label: opt.name, value: opt.id }))

      setRegions(region_list)
      setRegionOptions(region_options)
      setStarted(true)
    }
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, [])

  useEffect(() => {
    if (currentStep === 5) {
      try { loadCaptchaEnginge(6) } catch(e) {}
    }
  }, [currentStep])

  const handleSubmit = () => {
    if (
      !name ||
      !surname ||
      !father_name ||
      !mother_name ||
      !nid ||
      !card_nid_expiry_date ||
      !birthplace ||
      !birthdate ||
      !gender ||
      !phone ||
      !email ||
      !facebook_link ||
      !address ||
      !selected_region ||
      !selected_municipality.value ||
      !selected_unit.value ||
      !qv_code
    ) {
      setError('Ju lutemi plotësoni të gjithë fushat e domosdoshme.')
    } else {
      setApplyLoading(true)
      sendData()
    }
  }

  const sendData = () => {
    const data = {
      name,
      surname,
      father_name,
      mother_name,
      nid,
      card_nid_expiry_date,
      birthplace,
      birthdate: birthdate,
      gender,
      has_primary_education: yes_primary ? true : false,
      primary_education_desc,
      has_high_school: yes_highschool ? true : false,
      high_school_desc,
      has_university: yes_university ? true : false,
      university_desc,
      has_master_degree: yes_masters_degree ? true : false,
      master_degree_desc,
      has_scientific_title: yes_scientific_title ? true : false,
      scientific_title_desc,
      is_state_employed: yes_state_employed ? true : false,
      state_employed_position,
      is_private_sector_employed: yes_private_sector_employed ? true : false,
      private_sector_position,
      is_self_employed,
      is_unemployed,
      is_student,
      is_retired,
      phone: '+355' + phone.toString(),
      email,
      facebook_link,
      twitter_link,
      instagram_link,
      address,
      references,
      region_id: selected_region.value,
      municipality_id: selected_municipality.value,
      unit_id: selected_unit.value,
      qv_code: qv_code.toString(),
    }

    if (membership_year > 0) {
      data.membership_year = membership_year.toString()
    }

    let url = API_URL + APPLY_URL

    axios.post(url, data).then(response => {
      const resp = response.data
      setUUID(resp.action_uuid)
      setConfirmationId(resp.id)
      setSuccess('Të dhënat u kaluan me sukses. Ju lutemi kontrolloni SMS për kodin e konfirmimit.')
      setTimeout(()=>setSuccess(''), 10000)
      setApplied(true)
      setApplyLoading(false)
      setTime(120)
      setShouldUpdate(true)
    }
    ).catch( error => {
      let errorMsg = 'Pati një problem gjatë dërgimit të të dhënave.'
      if (error.response && error.response.data && error.response.data.length > 0) {
        errorMsg = error.response.data[0]
      }
      setError(errorMsg)
      setTimeout(()=>setError(''), 5000)
      setApplyLoading(false)
    })
  }

  useEffect(() => {
    if(shouldUpdate){
        const interval = setInterval(() => {
          if (!time) {
            setShouldUpdate(false)
          } else {
            setTime(time-1)
          }
        },
          1000
        );
        return () => clearInterval(interval);
    }
  }, [shouldUpdate, time]);

  const handleRefresh = () => {
    setRefreshLoading(true)
    const data = {
      action_uuid,
    }

    let url = API_URL + REGENERATE_URL
    axios.post(url, data).then(response => {
      setSuccess('Kodi u dërgua përsëri. Ju lutemi kontrolloni SMS për kodin e konfirmimit.')
      setTimeout(()=>setSuccess(''), 10000)
      setTime(120)
      setShouldUpdate(true)
      setRefreshLoading(false)
    }).catch(error => {
      setError('Pati një problem me rigjenerimin e kodit.')
      setTimeout(()=>setError(''), 5000)
      setRefreshLoading(false)
    })
  }

  const handleConfirm = () => {
    setConfirmLoading(true)
    const data = {
      confirmation_id,
      confirmation_code,
    }

    let url = API_URL + CONFIRM_URL
    axios.post(url, data).then(response => {
      setSuccess("Aplikimi juaj u krye me sukses! Ju lutemi prisni t'ju kontaktojë një kryetar OS-je mbi statusin e aplikimit tuaj.")
      setConfirmLoading(false)
      setConfirmed(true)
    }).catch(error => {
      let errorMsg = 'Pati një problem gjatë dërgimit të kodit.'
      if (error.response?.data?.Error) {
        errorMsg = error.response?.data?.Error
      }
      setError(errorMsg)
      setTimeout(()=>setError(''), 5000)
      setConfirmLoading(false)
    })
  }

  const verifyCaptcha = () => {
    let captchaOK = validateCaptcha(captchaMessage, false)
    if (captchaOK) {
      setCaptchaSuccess(true)
      setCaptchaError(false)
    } else {
      setCaptchaError(true)
    }
  }

  const validateStep = (step) => {
    switch (step) {
      case 0: // Personale
        if (!name) return 'Plotësoni emrin'
        if (!surname) return 'Plotësoni mbiemrin'
        if (!father_name) return 'Plotësoni atësinë'
        if (!mother_name) return 'Plotësoni mëmësinë'
        if (!birthplace) return 'Plotësoni vendlindjen'
        if (!birthdate) return 'Plotësoni datëlindjen'
        if (!nid) return 'Plotësoni Nr. Personal ID'
        if (!/^[A-Z]{1}[0-9]{8}[A-Z]{1}$/.test(nid)) return 'Formati i NID: A12345678Z'
        if (!card_nid_expiry_date) return 'Plotësoni datën e skadimit të kartës'
        if (!gender) return 'Zgjidhni gjininë'
        return null
      case 1: // Arsimimi
        return null // optional fields
      case 2: // Punësimi
        return null // optional fields
      case 3: // Kontakt
        if (!phone) return 'Plotësoni numrin e celularit'
        if (!/^[0-9]{9}$/.test(phone)) return 'Numri i celularit ka 9 shifra'
        if (!email) return 'Plotësoni emailin'
        if (!facebook_link) return 'Plotësoni linkun e Facebook'
        if (!address) return 'Plotësoni adresën'
        return null
      case 4: // Vendndodhja
        if (!selected_region || !selected_region.value) return 'Zgjidhni qarkun'
        if (!selected_municipality || !selected_municipality.value) return 'Zgjidhni bashkinë'
        if (!selected_unit || !selected_unit.value) return 'Zgjidhni njësinë administrative'
        if (!qv_code) return 'Plotësoni QV nr.'
        return null
      default:
        return null
    }
  }

  const goNext = () => {
    const validationError = validateStep(currentStep)
    if (validationError) {
      setStepError(validationError)
      setTimeout(() => setStepError(''), 4000)
      return
    }
    setStepError('')
    if (currentStep < STEPS.length - 1) {
      setCurrentStep(currentStep + 1)
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  const goPrev = () => {
    setStepError('')
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1)
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  const goToStep = (step) => {
    // Allow going back freely, but validate when going forward
    if (step > currentStep) {
      const validationError = validateStep(currentStep)
      if (validationError) {
        setStepError(validationError)
        setTimeout(() => setStepError(''), 4000)
        return
      }
    }
    setStepError('')
    setCurrentStep(step)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  // ===== STEP RENDERERS =====

  const renderStepPersonale = () => (
    <div className="step-content">
      <div className="section-card">
        <div className="section-title">Të dhënat personale</div>
        <Row>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Emri</Label>
              <AvField
                name="name"
                placeholder="Emri"
                type="text"
                value={name}
                onChange={e => setName(e.target.value)}
                errorMessage="Plotësoni emrin"
                className="form-control"
                validate={{ required: { value: true } }}
              />
            </FormGroup>
          </Col>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Mbiemri</Label>
              <AvField
                name="surname"
                placeholder="Mbiemri"
                type="text"
                value={surname}
                onChange={e => setSurname(e.target.value)}
                errorMessage="Plotësoni mbiemrin"
                className="form-control"
                validate={{ required: { value: true } }}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Atësia</Label>
              <AvField
                name="father_name"
                placeholder="Atësia"
                type="text"
                value={father_name}
                onChange={e => setFatherName(e.target.value)}
                errorMessage="Plotësoni atësinë"
                className="form-control"
                validate={{ required: { value: true } }}
              />
            </FormGroup>
          </Col>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Mëmësia</Label>
              <AvField
                name="mother_name"
                placeholder="Mëmësia"
                type="text"
                value={mother_name}
                onChange={e => setMotherName(e.target.value)}
                errorMessage="Plotësoni mëmësinë"
                className="form-control"
                validate={{ required: { value: true } }}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Vendlindja</Label>
              <AvField
                name="birthplace"
                placeholder="Vendlindja"
                type="text"
                value={birthplace}
                onChange={e => setBirthplace(e.target.value)}
                errorMessage="Plotësoni vendlindjen"
                className="form-control"
                validate={{ required: { value: true } }}
              />
            </FormGroup>
          </Col>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Datëlindja</Label>
              <AvField
                name="birthdate"
                type="date"
                value={birthdate}
                onChange={e => setBirthdate(e.target.value)}
                errorMessage="Plotësoni datën"
                className="form-control"
                validate={{ required: { value: true } }}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Nr. Personal ID</Label>
              <AvField
                name="nid"
                placeholder="A12345678Z"
                type="text"
                value={nid}
                onChange={e => setNid(e.target.value)}
                errorMessage={
                  !nid.length ?
                  "Plotësoni NID-in" :
                  'Formati: A12345678Z'
                }
                className="form-control"
                validate={{
                  required: { value: true },
                  pattern: { value: '^[A-Z]{1}[0-9]{8}[A-Z]{1}$' },
                }}
              />
            </FormGroup>
          </Col>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Data e skadimit të kartës</Label>
              <AvField
                name="card_nid_expiry_date"
                type="date"
                value={card_nid_expiry_date}
                onChange={e => setNidExpiry(e.target.value)}
                errorMessage="Plotësoni datën e skadimit"
                className="form-control"
                validate={{ required: { value: true } }}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Gjinia</Label>
              <AvRadioGroup inline name="genderradio" required>
                <AvRadio label="M" value="M" onClick={()=>setGender('M')} />
                <AvRadio label="F" value="F" onClick={()=>setGender('F')} />
              </AvRadioGroup>
            </FormGroup>
          </Col>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Viti i Anëtarësimit</Label>
              <div>
                <DatePicker
                  className="form-control"
                  selected={startDate}
                  onChange={(date) => {
                    setStartDate(date)
                    setMembershipYear(date.getFullYear())
                  }}
                  showYearPicker
                  dateFormat="yyyy"
                />
              </div>
            </FormGroup>
          </Col>
        </Row>
      </div>
    </div>
  )

  const renderStepArsimimi = () => (
    <div className="step-content">
      <div className="section-card">
        <div className="section-title">Arsimimi</div>

        <Col md={12}>
          <FormGroup className="mb-3">
            <Label className="bold-label mb-1">Shkollë 9-Vjeçare</Label>
            <Row>
              <Col md={4}>
                <div className="form-check form-check-inline">
                  <input type="radio" name="yes_primary" className="form-check-input" checked={yes_primary} onClick={()=>{
                    setYesPrimary(!yes_primary)
                    setNoPrimary(false)
                    setPrimaryName('')
                  }}/>
                  <label className="custom-control-label">Po</label>
                </div>
                <div className="form-check form-check-inline">
                  <input type="radio" name="no_primary" className="form-check-input" checked={no_primary} onClick={()=>{
                    setNoPrimary(!no_primary)
                    setYesPrimary(false)
                    setPrimaryName('')
                  }}/>
                  <label className="custom-control-label">Jo</label>
                </div>
              </Col>
              <Col md={8}>
                {yes_primary &&
                  <Input
                    type="text"
                    value={primary_education_desc}
                    onChange={e => setPrimaryName(e.target.value)}
                    className="form-control"
                    placeholder="Profesioni"
                  />
                }
              </Col>
            </Row>
          </FormGroup>
        </Col>

        <Col md={12}>
          <FormGroup className="mb-3">
            <Label className="bold-label mb-1">Shkollë e Mesme</Label>
            <Row>
              <Col md={4}>
                <div className="form-check form-check-inline">
                  <input type="radio" name="yes_highschool" className="form-check-input" checked={yes_highschool} onClick={()=>{
                    setYesHighschool(!yes_highschool)
                    setNoHighschool(false)
                    setHighSchoolName('')
                  }}/>
                  <label className="custom-control-label">Po</label>
                </div>
                <div className="form-check form-check-inline">
                  <input type="radio" name="no_highschool" className="form-check-input" checked={no_highschool} onClick={()=>{
                    setNoHighschool(!no_highschool)
                    setYesHighschool(false)
                    setHighSchoolName('')
                  }}/>
                  <label className="custom-control-label">Jo</label>
                </div>
              </Col>
              <Col md={8}>
                {yes_highschool &&
                  <Input
                    type="text"
                    value={high_school_desc}
                    onChange={e => setHighSchoolName(e.target.value)}
                    className="form-control"
                    placeholder="Profesioni"
                  />
                }
              </Col>
            </Row>
          </FormGroup>
        </Col>

        <Col md={12}>
          <FormGroup className="mb-3">
            <Label className="bold-label mb-1">Universitar</Label>
            <Row>
              <Col md={4}>
                <div className="form-check form-check-inline">
                  <input type="radio" name="yes_university" className="form-check-input" checked={yes_university} onClick={()=>{
                    setYesUniversity(!yes_university)
                    setNoUniversity(false)
                    setUniversityName('')
                  }}/>
                  <label className="custom-control-label">Po</label>
                </div>
                <div className="form-check form-check-inline">
                  <input type="radio" name="no_university" className="form-check-input" checked={no_university} onClick={()=>{
                    setNoUniversity(!no_university)
                    setYesUniversity(false)
                    setUniversityName('')
                  }}/>
                  <label className="custom-control-label">Jo</label>
                </div>
              </Col>
              <Col md={8}>
                {yes_university &&
                  <Input
                    type="text"
                    value={university_desc}
                    onChange={e => setUniversityName(e.target.value)}
                    className="form-control"
                    placeholder="Profesioni"
                  />
                }
              </Col>
            </Row>
          </FormGroup>
        </Col>

        <Col md={12}>
          <FormGroup className="mb-3">
            <Label className="bold-label mb-1">Pasuniversitar</Label>
            <Row>
              <Col md={4}>
                <div className="form-check form-check-inline">
                  <input type="radio" name="yes_masters_degree" className="form-check-input" checked={yes_masters_degree} onClick={()=>{
                    setYesMasters(!yes_masters_degree)
                    setNoMasters(false)
                    setMastersName('')
                  }}/>
                  <label className="custom-control-label">Po</label>
                </div>
                <div className="form-check form-check-inline">
                  <input type="radio" name="no_masters_degree" className="form-check-input" checked={no_masters_degree} onClick={()=>{
                    setNoMasters(!no_masters_degree)
                    setYesMasters(false)
                    setMastersName('')
                  }}/>
                  <label className="custom-control-label">Jo</label>
                </div>
              </Col>
              <Col md={8}>
                {yes_masters_degree &&
                  <Input
                    type="text"
                    value={master_degree_desc}
                    onChange={e => setMastersName(e.target.value)}
                    className="form-control"
                    placeholder="Profesioni"
                  />
                }
              </Col>
            </Row>
          </FormGroup>
        </Col>

        <Col md={12}>
          <FormGroup className="mb-3">
            <Label className="bold-label mb-1">Tituj Shkencorë</Label>
            <Row>
              <Col md={4}>
                <div className="form-check form-check-inline">
                  <input type="radio" name="yes_scientific_title" className="form-check-input" checked={yes_scientific_title} onClick={()=>{
                    setYesScientific(!yes_scientific_title)
                    setNoScientific(false)
                    setScientificName('')
                  }}/>
                  <label className="custom-control-label">Po</label>
                </div>
                <div className="form-check form-check-inline">
                  <input type="radio" name="no_scientific_title" className="form-check-input" checked={no_scientific_title} onClick={()=>{
                    setNoScientific(!no_scientific_title)
                    setYesScientific(false)
                    setScientificName('')
                  }}/>
                  <label className="custom-control-label">Jo</label>
                </div>
              </Col>
              <Col md={8}>
                {yes_scientific_title &&
                  <Input
                    type="text"
                    value={scientific_title_desc}
                    onChange={e => setScientificName(e.target.value)}
                    className="form-control"
                    placeholder="Profesioni"
                  />
                }
              </Col>
            </Row>
          </FormGroup>
        </Col>
      </div>
    </div>
  )

  const renderStepPunesimi = () => (
    <div className="step-content">
      <div className="section-card">
        <div className="section-title">Punësimi</div>

        <Col md={12}>
          <FormGroup className="mb-3">
            <Label className="bold-label mb-1">Sektor Shtetëror</Label>
            <Row>
              <Col md={4}>
                <div className="form-check form-check-inline">
                  <input type="radio" name="yes_state_employed" className="form-check-input" checked={yes_state_employed} onClick={()=>{
                    setYesStateEmployed(!yes_state_employed)
                    setNoStateEmployed(false)
                    setStateName('')
                  }}/>
                  <label className="custom-control-label">Po</label>
                </div>
                <div className="form-check form-check-inline">
                  <input type="radio" name="no_state_employed" className="form-check-input" checked={no_state_employed} onClick={()=>{
                    setNoStateEmployed(!no_state_employed)
                    setYesStateEmployed(false)
                    setStateName('')
                  }}/>
                  <label className="custom-control-label">Jo</label>
                </div>
              </Col>
              <Col md={8}>
                {yes_state_employed &&
                  <Input
                    type="text"
                    value={state_employed_position}
                    onChange={e => setStateName(e.target.value)}
                    className="form-control"
                    placeholder="Pozicioni"
                  />
                }
              </Col>
            </Row>
          </FormGroup>
        </Col>

        <Col md={12}>
          <FormGroup className="mb-3">
            <Label className="bold-label mb-1">Sektor Privat</Label>
            <Row>
              <Col md={4}>
                <div className="form-check form-check-inline">
                  <input type="radio" name="yes_private_sector_employed" className="form-check-input" checked={yes_private_sector_employed} onClick={()=>{
                    setYesPrivateSector(!yes_private_sector_employed)
                    setNoPrivateSector(false)
                    setPrivateName('')
                  }}/>
                  <label className="custom-control-label">Po</label>
                </div>
                <div className="form-check form-check-inline">
                  <input type="radio" name="no_private_sector_employed" className="form-check-input" checked={no_private_sector_employed} onClick={()=>{
                    setNoPrivateSector(!no_private_sector_employed)
                    setYesPrivateSector(false)
                    setPrivateName('')
                  }}/>
                  <label className="custom-control-label">Jo</label>
                </div>
              </Col>
              <Col md={8}>
                {yes_private_sector_employed &&
                  <Input
                    type="text"
                    value={private_sector_position}
                    onChange={e => setPrivateName(e.target.value)}
                    className="form-control"
                    placeholder="Pozicioni"
                  />
                }
              </Col>
            </Row>
          </FormGroup>
        </Col>

        <Row>
          <Col md={3}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Vetëpunësim</Label>
              <AvCheckboxGroup inline name="self_employed" onClick={() => setSelfEmployedStatus(!is_self_employed)}>
                <AvCheckbox value="1" />
              </AvCheckboxGroup>
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">I / E Papunë</Label>
              <AvCheckboxGroup inline name="unemployed" onChange={() => setUnemployedStatus(!is_unemployed)}>
                <AvCheckbox value="1" />
              </AvCheckboxGroup>
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Student</Label>
              <AvCheckboxGroup inline name="student" onClick={() => setStudentStatus(!is_student)}>
                <AvCheckbox value="1" />
              </AvCheckboxGroup>
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Pension</Label>
              <AvCheckboxGroup inline name="pension" onClick={() => setRetiredStatus(!is_retired)}>
                <AvCheckbox value="1" />
              </AvCheckboxGroup>
            </FormGroup>
          </Col>
        </Row>
      </div>
    </div>
  )

  const renderStepKontakt = () => (
    <div className="step-content">
      <div className="section-card">
        <div className="section-title">Kontakt</div>

        <Row>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Celular</Label>
              <InputGroup>
                <InputGroupAddon
                  style={{width: '20%', display: 'block'}}
                  addonType="prepend">
                  <InputGroupText>+355</InputGroupText>
                </InputGroupAddon>
                <div style={{width: '80%', display: 'block'}}>
                  <AvField
                    name="phone"
                    placeholder={691234567}
                    type="number"
                    value={phone}
                    onChange={e => setPhone(e.target.value)}
                    errorMessage={
                      !phone.length ?
                      "Plotësoni numrin" :
                      "Numri ka 9 shifra"
                    }
                    className="form-control"
                    validate={{
                      required: { value: true },
                      pattern: { value: '^[0-9]{9}$' },
                    }}
                  />
                </div>
              </InputGroup>
            </FormGroup>
          </Col>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">E-mail</Label>
              <AvField
                name="email"
                placeholder="emri@email.com"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                errorMessage={
                  !email.length ?
                    "Plotësoni emailin"
                  :
                    "Formati: emri@email.com"
                }
                className="form-control"
                validate={{
                  email: true,
                  required: true,
                }}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Linku i Facebook</Label>
              <AvField
                name="facebook"
                placeholder="facebook.com/profili"
                type="text"
                value={facebook_link}
                onChange={e => setFacebookLink(e.target.value)}
                errorMessage="Plotësoni linkun"
                className="form-control"
                validate={{ required: { value: true } }}
              />
            </FormGroup>
          </Col>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Twitter Link</Label>
              <AvField
                name="twitter_link"
                placeholder="twitter.com/profili"
                type="text"
                value={twitter_link}
                onChange={e => setTwitterLink(e.target.value)}
                className="form-control"
                validate={{ required: { value: false } }}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Instagram Link</Label>
              <AvField
                name="instagram_link"
                placeholder="instagram.com/profili"
                type="text"
                value={instagram_link}
                onChange={e => setInstagramLink(e.target.value)}
                className="form-control"
                validate={{ required: { value: false } }}
              />
            </FormGroup>
          </Col>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Adresa e plotë e banimit</Label>
              <AvField
                name="address"
                placeholder="123 Rruga Skënderbeu"
                type="text"
                value={address}
                onChange={e => setAddress(e.target.value)}
                errorMessage="Plotësoni adresën"
                className="form-control"
                validate={{ required: { value: true } }}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Referenca</Label>
              <AvField
                name="references"
                placeholder="Referenca"
                type="text"
                value={references}
                onChange={e => setReferences(e.target.value)}
                className="form-control"
                validate={{ required: { value: false } }}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    </div>
  )

  const renderStepVendndodhja = () => (
    <div className="step-content">
      <div className="section-card">
        <div className="section-title">Vendndodhja</div>

        <Row>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Qarku</Label>
              <Select
                name="region"
                value={selected_region}
                onChange={handleSelectRegion}
                options={region_options}
                classNamePrefix="select2-selection"
                placeholder="Zgjidhni"
                noOptionsMessage={()=>"Pa opsione"}
              />
            </FormGroup>
          </Col>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Bashkia</Label>
              <Select
                name="municipality"
                value={selected_municipality}
                onChange={handleSelectMunicipality}
                options={municipality_options}
                classNamePrefix="select2-selection"
                placeholder="Zgjidhni"
                noOptionsMessage={()=>"Pa opsione"}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">Njësia Administrative</Label>
              <Select
                name="unit"
                value={selected_unit}
                onChange={handleSelectUnit}
                options={unit_options}
                classNamePrefix="select2-selection"
                placeholder="Zgjidhni"
                noOptionsMessage={()=>"Pa opsione"}
              />
            </FormGroup>
          </Col>
          <Col md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label className="bold-label mb-1">QV nr.</Label>
              <AvField
                name="qv_code"
                placeholder="1234"
                type="number"
                min={0}
                value={qv_code}
                onChange={e => setQVCode(e.target.value)}
                errorMessage={ !qv_code.length ?
                  "Plotësoni QV-në"
                  :
                  "Vetëm numra lejohen"
                }
                className="form-control"
                validate={{
                  required: true,
                  pattern: { value: '^[0-9]*$' },
                }}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    </div>
  )

  const renderStepKonfirmimi = () => (
    <div className="step-content">
      <div className="section-card">
        <div className="section-title">Konfirmimi</div>

        <Row>
          <div className="d-flex justify-content-left">
            <AvCheckboxGroup inline name="checkboxExample2">
              <AvCheckbox
                disabled={applied}
                label="Dakordësoj për përdorimin e të dhënave personale."
                value="Yes"
                onChange={()=>setPrivacy(!privacy)}
              />
            </AvCheckboxGroup>
          </div>
        </Row>

        <Row className="mb-3">
          <div className="d-flex justify-content-left">
            <Input
              disabled={true}
              type="textarea"
              rows="4"
              className="privacy-box"
              placeholder='Duke u regjistruar në plateformën e anëtarësisë ju jeni dakort me Kushtet e përdorimit, dhe ju jepni pëlqimin/miratimin tuaj për përdorimin e të dhënave personale, të cilat do të përpunohen në përputhje të plotë me percaktimet e Ligjit nr.9887, datë 10.03.2008, "Për Mbrojtjen e të Dhënave Personale", të ndryshuar, aktet nënligjore të Komisionerit për Mbrojtjen e të Dhënave Personale si dhe legjislacionin Shqiptar në fuqi.'
            />
          </div>
        </Row>

        <div className="captcha-wrapper mb-4">
          <Row className="justify-content-center align-items-center">
            <Col md={3} sm={12} className="mb-2">
              <LoadCanvasTemplate reloadText="Rikrijo Captcha" />
            </Col>
            <Col md={4} sm={12} className="mb-2">
              <FormGroup className="mb-0">
                <Input
                  disabled={captchaSuccess}
                  invalid={captchaError}
                  placeholder="Shkruani kodin"
                  name="user_captcha_input"
                  type="text"
                  value={captchaMessage}
                  onChange={e => {
                    setCaptchaMessage(e.target.value)
                    setCaptchaError(false)
                  }}
                />
                <FormFeedback>Kodi nuk është njësoj</FormFeedback>
              </FormGroup>
            </Col>
            <Col md={3} sm={12} className="mb-2">
              <Button
                disabled={captchaSuccess}
                className="btn-ps"
                onClick={verifyCaptcha}
              >
                {captchaSuccess ? <FaCheck /> : "Verifiko"}
              </Button>
            </Col>
          </Row>
        </div>

        <div className="d-flex justify-content-center">
          <Button
            disabled={applied || !privacy || !captchaSuccess || apply_loading}
            type="submit"
            className="btn-ps"
            style={{ width: '180px', padding: '0.75rem' }}
          >
            {(!applied && !apply_loading && "Apliko") ||
              (apply_loading &&
                <IconContext.Provider value={{ color: "white", className: "icon-spin" }}>
                  <div><FaSpinner /></div>
                </IconContext.Provider>) ||
              (applied && <FaCheck />)
            }
          </Button>
        </div>

        {applied && !confirmed &&
          <div className="confirmation-section">
            <Row className="justify-content-center">
              <Col md={8}>
                <Row className="align-items-center">
                  <Col md={6} className="mb-2">
                    <AvForm className="needs-validation">
                      <AvField
                        name="code"
                        placeholder="123456"
                        type="text"
                        errorMessage={
                          !confirmation_code.length ?
                          "Plotësoni kodin" :
                          'Kodi ka 6 shifra'
                        }
                        className="form-control"
                        validate={{
                          required: { value: true },
                          pattern: { value: '^[0-9]{6}$' },
                        }}
                        value={confirmation_code}
                        onChange={e => setConfirmationCode(e.target.value)}
                      />
                    </AvForm>
                  </Col>
                  <Col md={3} className="mb-2">
                    <Button
                      disabled={confirmed || confirm_loading || !(/^[0-9]{6}$/).test(confirmation_code)}
                      className="btn-ps"
                      style={{ width: '100%' }}
                      onClick={handleConfirm}
                    >
                      {(!confirm_loading && "Dërgo") ||
                        (confirm_loading &&
                        <IconContext.Provider value={{ color: "white", className: "icon-spin" }}>
                          <div><FaSpinner /></div>
                        </IconContext.Provider>)
                      }
                    </Button>
                  </Col>
                  <Col md={3} className="mb-2">
                    <Button
                      disabled={time > 0 || refresh_loading}
                      className="btn-ps-outline"
                      style={{ width: '100%' }}
                      onClick={handleRefresh}
                    >
                      {(time > 0 && Math.floor(time/60) + " : " + time%60) ||
                        (refresh_loading &&
                          <IconContext.Provider value={{ color: "#7b2d8e", className: "icon-spin" }}>
                            <div><FaSpinner /></div>
                          </IconContext.Provider>) ||
                        "Gjenero"
                      }
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        }
      </div>
    </div>
  )

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 0: return renderStepPersonale()
      case 1: return renderStepArsimimi()
      case 2: return renderStepPunesimi()
      case 3: return renderStepKontakt()
      case 4: return renderStepVendndodhja()
      case 5: return renderStepKonfirmimi()
      default: return renderStepPersonale()
    }
  }

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <div id="main-content">
          <Container style={{width: '100%', height: '100%'}} fluid={true}>
            <Row className="justify-content-center">
              <Col lg={10} md={12}>
                <div className="logo-section">
                  <img className="main-logo" src={ps_logo} alt="PS Logo" />
                  <img className="flower-logo" src={ps_flower} alt="" />
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col lg={10} md={12}>
                <Card className="main-card">
                  <CardBody>
                    <div className="text-center mt-2 mb-1">
                      <h2 className="form-main-title">
                        PARTIA SOCIALISTE E SHQIPËRISË
                      </h2>
                      <p className="form-subtitle">Formular Anëtarësimi</p>
                    </div>

                    {/* Stepper */}
                    <div className="stepper-wrapper">
                      {STEPS.map((step, index) => (
                        <div
                          key={index}
                          className={`stepper-step ${index === currentStep ? 'active' : ''} ${index < currentStep ? 'completed' : ''}`}
                          onClick={() => goToStep(index)}
                        >
                          <div className="stepper-circle">
                            {index < currentStep ? <FaCheck size={14} /> : index + 1}
                          </div>
                          <div className="stepper-label">
                            {isMobile ? step.shortLabel : step.label}
                          </div>
                        </div>
                      ))}
                    </div>

                    <Row className="justify-content-center">
                      <Col md={11}>
                        <AvForm onSubmit={handleSubmit} className="needs-validation">

                          {renderCurrentStep()}

                          {/* Step validation error */}
                          {stepError &&
                            <Alert color="warning" className="mt-3">
                              {stepError}
                            </Alert>
                          }

                          {/* Navigation */}
                          <div className="step-navigation">
                            <div>
                              {currentStep > 0 && (
                                <Button
                                  type="button"
                                  className="btn-ps-outline"
                                  onClick={goPrev}
                                >
                                  <FaArrowLeft className="mr-2" /> Mbrapa
                                </Button>
                              )}
                            </div>
                            <div>
                              {currentStep < STEPS.length - 1 && (
                                <Button
                                  type="button"
                                  className="btn-ps"
                                  onClick={goNext}
                                >
                                  Vazhdo <FaArrowRight className="ml-2" />
                                </Button>
                              )}
                            </div>
                          </div>

                          {/* Alerts */}
                          <Row className="mt-4">
                            <Col md={12}>
                              {success &&
                                <Alert color="success">{success}</Alert>
                              }
                              {error &&
                                <Alert color="danger">{error}</Alert>
                              }
                            </Col>
                          </Row>
                        </AvForm>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
}

export default App;
